/** Ortszeit für `datetime-local`; ein unlesbarer Wert bleibt leer statt die Seite zu sprengen. */
export function utcInput(value?: string) {
  if (!value) return '';
  const instant = new Date(value);
  if (Number.isNaN(instant.getTime())) return '';
  instant.setMinutes(instant.getMinutes() - instant.getTimezoneOffset());
  return instant.toISOString().slice(0, 16);
}

/**
 * Zeitpunkt aus `datetime-local`. Ein fünfstelliges Jahr (Tippfehler) ergibt kein Datum – der Filter
 * wirkt dann nicht, statt mit „Invalid Date“ abzustürzen.
 */
export function utcInstant(value: string) {
  if (!value || !/^\d{4}-/.test(value)) return undefined;
  const instant = new Date(value);
  return Number.isNaN(instant.getTime()) ? undefined : instant.toISOString();
}

/** Kalendertag aus `date`: nur vierstellige Jahre. */
export const dayInput = (value: string) => (/^\d{4}-\d{2}-\d{2}$/.test(value) ? value : undefined);

/** Obergrenze für Datumsfelder: hält die Jahreseingabe bei vier Stellen. */
export const DATE_MAX = { date: '9999-12-31', 'datetime-local': '9999-12-31T23:59' } as const;
